export default __webpack_public_path__ + "static/media/avatar_lion4.31301ed7.mp3";